export default __webpack_public_path__ + "7fe29d3a843cf78f7899ebc7cbbc5892.svg";